/**
 * VERA-842: a flag the auth surfaces set when they own a step that must render
 * AFTER the session token is minted — today the "set a new password" step at
 * the end of a password reset.
 *
 * `ProtectedAuthRoute` redirects authenticated users off the auth routes, so
 * without this flag the post-verify step is unmountable: the token lands, the
 * guard fires, and the user is bounced to HOME mid-flow.
 *
 * sessionStorage (not React state) because the guard lives above the auth page
 * in the tree and re-renders independently of it.
 */
export const PENDING_POST_AUTH_STEP_KEY = 'vera:pendingPostAuthStep';

export const markPendingPostAuthStep = () => {
  try {
    window.sessionStorage.setItem(PENDING_POST_AUTH_STEP_KEY, '1');
  } catch {
    // Private-mode / storage-disabled: the step just won't survive the guard.
  }
};

export const clearPendingPostAuthStep = () => {
  try {
    window.sessionStorage.removeItem(PENDING_POST_AUTH_STEP_KEY);
  } catch {
    // no-op
  }
};
